import React from 'react';
import classnames from 'classnames';
import { Trans } from 'react-i18next';
import Timestamp from '../../../Timestamp';

import s from './PublishedTime.scss';

export interface Props {
  publishedTime?: string;
  withoutText?: boolean;
  isStash?: boolean;
  className?: string;
}

const PublishedTime: React.FC<Props> = ({ publishedTime, withoutText, isStash, className }) => {
  if (!publishedTime) {
    return null;
  }

  const timestamp = (
    <Timestamp timestamp={publishedTime} showTooltip={true} showFullLengthOnMobile />
  );

  if (isStash) {
    return (
      <span className={classnames(s['root'], className)}>
        <Trans i18nKey={'deviation.details.uploadedTime'}>Uploaded: {timestamp}</Trans>
      </span>
    );
  }

  return (
    <span className={classnames(s['root'], className)}>
      {withoutText ? (
        timestamp
      ) : (
        <Trans i18nKey={'deviation.details.publishedTime'}>Published: {timestamp}</Trans>
      )}
    </span>
  );
};

PublishedTime.displayName = 'PublishedTime';
export default PublishedTime;
